import BayToast from './BayToast';
import BayToastNew from './BayToastNew';
import { useToast, ToastProvider } from './BayToastNew.hook';

BayToastNew.useToast = useToast;
BayToastNew.ToastProvider = ToastProvider;

export { BayToastNew, useToast, ToastProvider };

export default BayToast;
